import React from 'react'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { ChevronDownIcon, ArrowDownOnSquareStackIcon, TrashIcon } from '@heroicons/react/20/solid'

export default function ButtonDropdown(props) {
  const { buttonText, dropdownItems } = props
  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
          {buttonText}
          <ChevronDownIcon aria-hidden="true" className="-mr-1 h-5 w-5 text-gray-400" />
        </MenuButton>
      </div>

      <MenuItems
        transition
        className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
      >
        <div className="py-1">
          {dropdownItems.map((item) => (
            <MenuItem key={item.text}>
              {item.method === 'post' ? (
                <form method="post" action={`${item.url}.xlsx`} data-confirm={item.confirm} className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900">
                  <button type="submit" className="group flex items-start text-start">
                    {item.text.includes('Export') ? <ArrowDownOnSquareStackIcon className="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" /> : null}
                    {item.text.includes('Destroy') ? <TrashIcon className="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" /> : null}
                    {item.text}
                  </button>
                  <input name="authenticity_token" type="hidden" value={document.querySelector('meta[name="csrf-token"]').getAttribute('content')} autoComplete="off" />
                </form>
              ) : (
                <a
                  href={item.url}
                  className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900"
                >
                  {item.text}
                </a>
              )}
            </MenuItem>
          ))}
        </div>
      </MenuItems>
    </Menu>
  )
}
